module.exports = __webpack_public_path__ + "static/media/tddz_en.fe4a1ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tddz_en.png
// module id = 1652
// module chunks = 0